var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Person_Iro",
    transform: "translate(0 -2.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon-bckgrd",
    y: 2.3,
    className: "st0",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_306",
    className: "st1",
    d: "M26.1,27.8c-0.4-2.5-1.9-4.7-4-6.1c-2.1-1.4-4.5-2.1-7-2.1l0,0c-2.5,0-4.9,0.7-6.9,2.1 c-2.1,1.4-3.6,3.6-4,6.1c-0.2,0.9,0.3,1.9,1.3,2.1c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0.1h18.6c0.9,0,1.7-0.8,1.7-1.7c0,0,0-0.1,0-0.1 C26.1,28.1,26,28,26.1,27.8z M24.4,28.1v0.1H5.8v-0.1c0.4-2,1.6-3.9,3.3-5c1.8-1.2,3.9-1.8,6-1.8l0,0c2.1,0,4.2,0.6,6,1.8 C22.8,24.3,23.9,26.1,24.4,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_8",
    className: "st1",
    d: "M15.1,18.9c-1.4,0-2.8-0.7-3.7-1.8c-1.1-1.2-1.7-2.7-1.8-4.2v-0.7 c0-1.9,1.1-3.7,2.7-4.7c0.1,0.5,0.3,1.1,0.5,1.7c-1.1,0.8-1.7,2.2-1.5,3.6c0.2,2.4,1.9,4.4,3.8,4.4s3.6-2,3.8-4.4v-0.5 c0-1.2-0.6-2.3-1.5-3c0.2-0.6,0.4-1.2,0.6-1.7c1.8,1.1,2.8,3.2,2.6,5.3c-0.1,1.6-0.7,3.1-1.8,4.2C17.9,18.3,16.5,18.9,15.1,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_307",
    className: "st1",
    d: "M13.3,5.6c0.7-1.4,3.4-1.4,4,0s-1.6,5.5-1.6,5.5h-1.2C14.5,11.1,12.6,7,13.3,5.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIroIcon);
export default __webpack_public_path__ + "static/media/PersonIroIcon.870996d74b34e9ffbf97cf3c902c3c29.svg";
export { ForwardRef as ReactComponent };